module.exports = __webpack_public_path__ + "static/media/Moskito.a819e1c6.png";